import { render, staticRenderFns } from "./UpdateProperties.vue?vue&type=template&id=810ecb4e&scoped=true&"
import script from "./UpdateProperties.vue?vue&type=script&lang=js&"
export * from "./UpdateProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810ecb4e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VCard,VCardText,VDivider,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('810ecb4e')) {
      api.createRecord('810ecb4e', component.options)
    } else {
      api.reload('810ecb4e', component.options)
    }
    module.hot.accept("./UpdateProperties.vue?vue&type=template&id=810ecb4e&scoped=true&", function () {
      api.rerender('810ecb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/components/Profile/UpdateProperties.vue"
export default component.exports